import axiosInstance from "../axiosClient";

export const getCallRecordings = async (limit = 40, start_key = "") => {
  const params = { limit };
  if (start_key) params.start_key = start_key;
  return axiosInstance.get("admins/call_recordings", { params });
};
